import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import {
  AudiencesSlice,
  createAudiencesSlice,
  initialAudiencesState,
} from 'app/audiences/infrastructore'
import {
  ConnectionsSlice,
  createConnectionsSlice,
  initialConnectionsState,
} from 'app/connections/infrastructure'
import { UserSlice, createUserSlice, initialUserState } from 'app/user/infrastructure'

import createApplicationSlice, {
  ApplicationSlice,
  initialApplicationState,
} from './createApplicationSlice'

export const storageKey = 'application-storage'

interface ResetAllActions {
  resetAll: () => void
}

type ApplicationStorage = ApplicationSlice &
  AudiencesSlice &
  ResetAllActions &
  ConnectionsSlice &
  UserSlice

const useApplicationStore = create<ApplicationStorage>()(
  persist(
    (...a) => ({
      ...createApplicationSlice(...a),
      ...createAudiencesSlice(...a),
      ...createConnectionsSlice(...a),
      ...createUserSlice(...a),
      resetAll: () => {
        const set = a[0]
        set({
          ...initialApplicationState,
          ...initialAudiencesState,
          ...initialConnectionsState,
          ...initialUserState,
        })
      },
    }),
    {
      name: storageKey,
    },
  ),
)

export default useApplicationStore
